(function ($) {
    $('.follow-wechat-section').click(function (e) {
        $('.wechat-light-box').hide();
        var target = $(this).attr('data-bs-target');
        $('#' + target).show();
        return;
    });

    $(".wechat-light-box .close-button").click(function (e) {
        var id = $(this).parent().attr('id');
        $('#' + id).hide();
        e.stopPropagation();
    });
}(window.jQuery));